import { CheckCircledOutline, ClipboardCheck, ClockOutline, DesignPencil, SettingsProfiles, Truck } from 'iconoir-react';

// Clases de Tailwind (paleta de tailwind.config.js) según la variante de estado_actual
export const VARIANT_CHIP = {
    active: 'bg-colorsixth text-colorprimary border-colorfifth',
    success: 'bg-colorprimarygreen/10 text-colorprimarygreen border-colorprimarygreen/30',
    error: 'bg-oldcolorthird text-oldcolorsecondary border-oldcolorprimary/30',
};

// Ícono de cada etapa (los códigos vienen del backend, siempre en este orden)
export const STAGE_ICONS = {
    REQUEST_CREATED: ClipboardCheck,
    VALIDATION: DesignPencil,
    ORDER_CREATED: SettingsProfiles,
    SCHEDULING: ClockOutline,
    TECHNICIAN_ASSIGNED: Truck,
    COMPLETED: CheckCircledOutline,
};

// Apariencia del círculo de cada etapa según su status
export const STAGE_STATUS_STYLES = {
    completed: { circle: 'bg-colorprimarygreen text-white', text: 'Completada' },
    current: { circle: 'bg-colorprimary text-white ring-4 ring-colorthird/40', text: 'En curso' },
    pending: { circle: 'bg-colorfifth text-gray-500', label: 'text-gray-400', text: 'Pendiente' },
    cancelled: { circle: 'bg-oldcolorprimary text-white', text: 'Cancelada' },
};

// La API entrega fechas ISO sin zona (ej. 2026-10-17T17:32:49): se muestran tal cual, sin convertir
export const formatDateTime = (value) => {
    if (!value) return null;
    const [date, time = ''] = String(value).split('T');
    const [year, month, day] = date.split('-');
    if (!year || !month || !day) return String(value);
    return time ? `${day}/${month}/${year} ${time.slice(0, 5)}` : `${day}/${month}/${year}`;
};

// coordinates llega como [longitud, latitud]; Google Maps espera { lat, lng }
export const toLatLng = (coordinates) => {
    if (!Array.isArray(coordinates) || coordinates.length !== 2) return null;
    const [lng, lat] = coordinates.map(Number);
    return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
};
